import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Category } from "../../../types/category";

interface CategorySheetProps {
  selectedCategory: string; // Level 1 categoryId
  categories: Category[];   // Complete list of categories from Redux
  onClose?: () => void;
}

const CategorySheet: React.FC<CategorySheetProps> = ({ selectedCategory, categories, onClose }) => {
  const navigate = useNavigate();

  // 1. Get Level 2 categories matching parent level 1
  const levelTwoCategories = categories.filter(
    (cat) => cat.level === 2 && cat.parentCategoryId === selectedCategory
  );

  // 2. Get Level 3 categories for a given level 2 parent ID
  const getLevelThree = (parentCategoryId: string) => {
    return categories.filter(
      (cat) => cat.level === 3 && cat.parentCategoryId === parentCategoryId
    );
  };

  if (!levelTwoCategories.length) { 
    return (
      <Box className="bg-white p-3 text-xs text-gray-400 text-center rounded">
        No subcategories found.
      </Box>
    );
  }

  return (
    <Box sx={{ zIndex: 1 }} className="bg-white lg:shadow-lg lg:h-[500px] overflow-y-auto rounded-lg">
      {/* Grid on mobile: 2 columns to maximize space usage */}
      <div className="grid grid-cols-2 lg:flex lg:flex-wrap text-sm gap-2 lg:gap-0 p-1 lg:p-0">
        {levelTwoCategories.map((item, index) => {
          const subItems = getLevelThree(item.categoryId);

          return (
            <div
              key={item.categoryId}
              className={`p-2.5 lg:p-8 rounded lg:rounded-none lg:w-[20%] ${
                index % 2 === 0 ? "bg-slate-50/80" : "bg-white"
              }`}
            >
              {/* Level 2 Subcategory Title */}
              <p 
                onClick={() => {
                  navigate("/products/" + item.categoryId);
                  if (onClose) onClose();
                }}
                className="text-amber-700 text-xs sm:text-sm mb-2 lg:mb-5 font-bold cursor-pointer hover:underline truncate"
              >
                {item.name}
              </p>

              {/* Level 3 Links */}
              <ul className="space-y-1.5 lg:space-y-3">
                {subItems.map((subItem) => (
                  <li
                    key={subItem.categoryId}
                    onClick={() => {
                      navigate("/products/" + subItem.categoryId);
                      if (onClose) onClose();
                    }}
                    className="text-xs sm:text-sm text-gray-600 hover:text-amber-600 cursor-pointer transition-colors truncate"
                  >
                    {subItem.name}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </Box>
  );
};

export default CategorySheet;